module.exports = __webpack_public_path__ + "img/folder-icon-orange.70b46c3e.svg";